import { Layout } from "shared/utils";
import Image from "shared/assets/index";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import style from "../styles/detailedConsultation.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getAssociatedInvoices, getContractNumbers } from "shared/api/services";
import { Spinner } from "shared/components";
import {
  ContractPerformanceIndicators,
  GeneralContractInformation,
} from "./conctact-details";
import { DataCustomizedComponent } from "shared/components/DataCustomized.component";
import { IRowsDataCustomized, Idata } from "shared/components/interfaces";
import EditIcon from "@mui/icons-material/Edit";
import { IDataContractPerfomanceIndicatos } from "../Models/IContractPerfomanceIndicatos";
import { columnsAssocietedInvoice } from "../helpers/columnsAssocietedInvoices";
import { accesRoles, Dispatch } from "shared";
import { useDispatch } from "react-redux";
import { useCheckRoleAccess } from "shared/hooks/useCheckRoleAccess";

export const SeeContractDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<Dispatch>();
  const { idContract } = useParams();
  const onNavigateBack = () => navigate(-1);
  const { checkRoles } = useCheckRoleAccess();
  const [loading, setLoading] = useState(false);
  const [dataAssociatedInvoices, setDataAssociatedInvoices] = useState<
    Idata<IRowsDataCustomized>
  >({
    columns: [],
    rows: [],
  });
  const [dataPerformanceIndicators, setDataPerformanceIndicators] =
    useState<IDataContractPerfomanceIndicatos>();
  const [contract, setContract] = useState<{ id: number; status: any }>({
    id: 0,
    status: {},
  });
  const [response, setResponse] = useState<any>(null);
  const [isEditing, setIsEditing] = useState(false);
  const updateContractResponse = (updatedContractNumber: string) => {
    setResponse((prev: any) =>
      prev ? { ...prev, contractNumber: updatedContractNumber } : null,
    );
  };

  const getContractsData = async () => {
    setResponse(null);
    getContractNumbers(idContract ?? "")
      ?.then((response) => {
        setDataPerformanceIndicators({
          title: "Información del contrato",
          values: [
            {
              percentFacturasRadicadas: {
                percent: parseFloat(response?.invoiceFiledPercentage ?? "0"),
                title: "Porcentaje de Facturas Radicadas",
                icon: "iconoPercent",
                md: 3,
              },
              cantidadFacturasRadicadas: {
                value: parseFloat(response?.numberInvoicesFiled ?? "0"),
                title: "Cantidad de Facturas Radicadas",
                icon: "iconNumber",
                md: 4,
              },
              valorTotalFacturasRadicadas: {
                value: `${response.totalValueInvoicesFiled ? response.totalValueInvoicesFiled.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0"}`,
                title: "Valor Total de Facturas Radicadas",
                icon: "iconoMoney",
                md: 4,
              },
            },
            {
              percentEjecucionFisica: {
                percent: parseFloat(
                  response?.physicalExecutionPercentage ?? "0",
                ),
                title: "Porcentaje de Ejecución Física",
                icon: "iconoPercent",
                md: 3,
              },
              cantidadFacturasAuditadas: {
                value: parseFloat(response?.numberInvoicesAudited ?? "0"),
                title: "Cantidad de Facturas Auditadas",
                icon: "iconNumber",
                md: 4,
              },
              valorTotalAuditado: {
                value: `${response?.totalValueInvoicesAudited ? response?.totalValueInvoicesAudited.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0"}`,
                title: "Valor Total Auditado",
                icon: "iconoMoney",
                md: 4,
              },
            },
            {
              percentEjecucionFinanciera: {
                percent: parseFloat(
                  response?.financialExecutionPercentage ?? "0",
                ),
                title: "Porcentaje de ejecución financiera",
                icon: "iconoPercent",
                md: 3,
              },
              cantidadFacturasConciliacion: {
                value: parseInt(response?.numberInvoicesConciliated ?? "0"),
                title: "Cantidad de facturas en Conciliación",
                icon: "iconNumber",
                md: 4,
              },
              valorTotalGlosasConciliacion: {
                value: `${response?.totalValueConciliatedGlosses ? response?.totalValueConciliatedGlosses.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0"}`,
                title: "Valor Total de Glosas en Conciliación",
                icon: "iconoMoney",
                md: 4,
              },
            },
            {
              percentGlosado: {
                percent: parseFloat(response?.glossedPercentage ?? "0"),
                title: "Porcentaje Glosado",
                icon: "iconoPercent",
                md: 3,
              },
              cantidadFacturasPagadas: {
                value: parseInt(response?.numberInvoicesPaid ?? "0"),
                title: "Cantidad de Facturas Pagadas",
                icon: "iconNumber",
                md: 4,
              },
              valorTotalFacturasPagadas: {
                value: `${response?.totalValueInvoicesPaid ? response?.totalValueInvoicesPaid.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0"}`,
                title: "Valor Total de Facturas Pagadas",
                icon: "iconoMoney",
                md: 4,
              },
            },
          ],
        });

        setResponse({ ...response, contractNumber: response.contractNumber });
        setContract({ id: response.id, status: response.state });
        setLoading(false);
      })
      .catch((error) => {
        console.log("error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getAssociatedInvoices(idContract ?? "")
      ?.then((response) => {
        const dataMapper: IRowsDataCustomized[] = response.map(
          (invoice, index) => {
            return {
              id: index,
              invoiceNumber: invoice.documentNumber
                ? invoice.documentNumber
                : "-",
              invoiceDate: invoice.issuedAt
                ? new Date(invoice.issuedAt).toLocaleDateString("en-US")
                : "-",
              state: invoice.state ? invoice.state : "-",
              fileNumber: invoice.filingNumber ? invoice.filingNumber : "-",
              filingDate: invoice.filingNumberCreatedAt
                ? new Date(invoice.filingNumberCreatedAt).toLocaleDateString(
                    "en-US",
                  )
                : "-",
              assignedAuditor: invoice.auditorName ? invoice.auditorName : "-",
              auditDate: invoice.auditAt
                ? new Date(invoice.auditAt).toLocaleDateString("en-US")
                : "-",
              invoiceTotal: `${invoice.totalValue ? invoice.totalValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0"}`,
              valueAssessed: `${invoice.endorsedValue ? invoice.endorsedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0"}`,
              glossedValue: `${invoice.glossedValue ? invoice.glossedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0"}`,
              acceptedValue: `${invoice.valueAccept ? invoice.valueAccept.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0"}`,
              valueNotAccepted: `${invoice.valueNotAccept ? invoice.valueNotAccept.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0"}`,
              sustainedValue: `${invoice.valueSustained ? invoice.valueSustained.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0"}`,
              valuePaid: `${invoice.valuePaid ? invoice.valuePaid.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0"}`,
              amountCreditNotes: `${invoice.creditTotalValue ? invoice.creditTotalValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0"}`,
              debitNoteValue: `${invoice.debitTotalValue ? invoice.debitTotalValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "0"}`,
            };
          },
        );
        setDataAssociatedInvoices({
          columns: columnsAssocietedInvoice,
          rows: dataMapper,
        });
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }, []);

  useEffect(() => {
    if (!isEditing) {
      setLoading(true);
      getContractsData();
    }
  }, [isEditing]);

  useEffect(() => {
    dispatch.menuDrawer.changeSelectedIndex(4);
    return () => {
      dispatch.electronicDocuments.cleanState();
    };
  }, []);

  return (
    <Layout>
      <div className={style.containerSeeContact} data-testid="see-contact">
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          className={style.conteinerHeader}
        >
          {!isEditing && checkRoles(accesRoles.adminUser) && (
            <Tooltip
              title="Editar Información del Contrato"
              placement="right"
              arrow
            >
              <IconButton
                onClick={() => setIsEditing(true)}
                data-testid="btn-edit-contract"
                className={`${style["viewButton"]} ${style["noHover"]}`}
                color="primary"
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          )}
          <IconButton
            className={`${style["viewButton"]} ${style["noHover"]}`}
            onClick={onNavigateBack}
            data-testid="button-back"
          >
            <img
              src={Image.iconoCerrar}
              className={`${style["sizeImg"]}`}
              alt="cerrar"
            />
          </IconButton>
        </Box>

        <section className={style.containerInfo}>
          {response && (
            <GeneralContractInformation
              contract={contract}
              response={response}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              onContractUpdate={updateContractResponse}
            />
          )}

          {dataPerformanceIndicators && (
            <ContractPerformanceIndicators data={dataPerformanceIndicators} />
          )}

          {dataAssociatedInvoices?.rows?.length > 0 && (
            <DataCustomizedComponent
              titleCard="Facturas Asociadas al Contrato"
              data={dataAssociatedInvoices}
              nameRowsDownloadedFileXlX={[
                { invoiceNumber: "Numero_de_factura" },
                { invoiceDate: "Fecha_factura" },
                { state: "Estado" },
                { fileNumber: "Numero_de_radicado" },
                { filingDate: "Fecha_de_radicado" },
                { assignedAuditor: "Auditor_asignado" },
                { auditDate: "Fecha_de_auditoria" },
                { invoiceTotal: "Total_factura" },
                { valueAssessed: "Valor_avalado" },
                { glossedValue: "Valor_glosado" },
                { acceptedValue: "Valor_aceptado" },
                { valueNotAccepted: "Valor_no_aceptado" },
                { sustainedValue: "Valor_sostenido" },
                { valuePaid: "Valor_pagado" },
                { amountCreditNotes: "Valor_notas_credito" },
                { debitNoteValue: "Valor_nota_debito" },
              ]}
              nameFileXLX="Reporte_facturas"
            />
          )}
        </section>
      </div>
      {loading && <Spinner />}
    </Layout>
  );
};
